import React from "react";

function Section({ title, children }) {
  return (
    <section className="mb-10">
      <h2 className="font-display text-2xl md:text-3xl font-bold mb-4">
        {title}
      </h2>
      <div className="text-white/70 leading-relaxed space-y-3">{children}</div>
    </section>
  );
}

export default function TermsConditions() {
  return (
    <main className="relative pt-40 pb-24">
      <div className="aurora-orb bg-[#8A2BE2] w-[500px] h-[500px] -top-20 -right-40 opacity-30" />
      <div className="container-x relative max-w-4xl">
        <div className="text-xs uppercase tracking-[0.25em] text-[#00F0FF] mb-4">
          Legal
        </div>
        <h1 className="font-display text-5xl md:text-6xl font-bold mb-3">
          Terms & <span className="aurora-text">Conditions</span>
        </h1>
        <p className="text-white/50 mb-12">Last Updated: March 27, 2026</p>

        <p className="text-white/70 leading-relaxed mb-10">
          Welcome to MonetiseUP. These Terms & Conditions ("Terms") govern your
          access to and use of the MonetiseUP website, platform, and services
          (collectively, the "Services"). By accessing or using our Services,
          you agree to be bound by these Terms. If you do not agree to these
          Terms, please do not use our Services.
        </p>

        <Section title="1. Acceptance of Terms">
          <p>
            By creating an account, accessing, or using the Services, you
            confirm that you have read, understood, and agree to be bound by
            these Terms, including any future modifications. These Terms
            constitute a legally binding agreement between you and MonetiseUP.
          </p>
        </Section>

        <Section title="2. Description of Services">
          <p>
            MonetiseUP provides an ad-tech platform designed to connect
            publishers with advertisers. Our Services include, but are not
            limited to, ad serving, programmatic advertising, audience
            targeting, real-time bidding, analytics, and reporting tools for
            both publishers and advertisers.
          </p>
        </Section>

        <Section title="3. User Obligations">
          <ul className="list-disc list-inside space-y-1.5 marker:text-[#00F0FF]">
            <li>You must be at least 18 years old to use our Services.</li>
            <li>You agree to provide accurate, current, and complete information during registration and use of the Services.</li>
            <li>You are responsible for maintaining the confidentiality of your account credentials.</li>
            <li>You agree not to use the Services for any illegal or unauthorized purpose.</li>
            <li>Publishers agree to adhere to our ad placement guidelines and content policies.</li>
            <li>Advertisers agree to comply with all applicable advertising laws and regulations.</li>
          </ul>
        </Section>

        <Section title="4. Intellectual Property">
          <p>
            All content, trademarks, service marks, trade names, logos, and
            intellectual property displayed on the MonetiseUP platform are the
            property of MonetiseUP or its licensors. You may not use, reproduce,
            or distribute any content from our Services without explicit written
            permission.
          </p>
        </Section>

        <Section title="5. Disclaimers">
          <p>
            The Services are provided "as is" and "as available" without any
            warranties of any kind, either express or implied, including but not
            limited to implied warranties of merchantability, fitness for a
            particular purpose, or non-infringement. MonetiseUP does not
            guarantee that the Services will be uninterrupted, error-free, or
            secure.
          </p>
        </Section>

        <Section title="6. Limitation of Liability">
          <p>
            To the fullest extent permitted by law, MonetiseUP shall not be
            liable for any indirect, incidental, special, consequential, or
            punitive damages, or any loss of profits or revenues, whether
            incurred directly or indirectly, or any loss of data, use, goodwill,
            or other intangible losses, resulting from (a) your access to or use
            of or inability to access or use the Services; (b) any conduct or
            content of any third party on the Services; or (c) unauthorized
            access, use, or alteration of your transmissions or content.
          </p>
        </Section>

        <Section title="7. Governing Law">
          <p>
            These Terms shall be governed by and construed in accordance with
            the laws of India, without regard to its conflict of law principles.
          </p>
        </Section>

        <Section title="8. Changes to Terms">
          <p>
            MonetiseUP reserves the right to modify or revise these Terms at any
            time. We will notify you of any changes by posting the updated Terms
            on our website. Your continued use of the Services after any such
            changes constitutes your acceptance of the new Terms.
          </p>
        </Section>

        <Section title="9. Contact Us">
          <p>
            If you have any questions about these Terms, please contact us at{" "}
            <a
              className="text-[#00F0FF] hover:underline"
              href="mailto:contact@monetiseup.com"
            >
              contact@monetiseup.com
            </a>
            .
          </p>
        </Section>
      </div>
    </main>
  );
}
